import axios from 'axios'
import defaultOptions from '../../api/defaultoption'
import { StatusNegociacao } from '../../types/negociacao'
import { GetVendasPromovidasResponse } from '../../types/vendasPromovidas'

export async function getVendasPromovidasList(
  CodigoPromotor: string,
  IdPedido?: StatusNegociacao | string,
  DataInicial?: string,
  DataFinal?: string,
  Page?: number,
  PageSize?: number
): Promise<GetVendasPromovidasResponse> {
  let page = !!Page ? `&Page=${Page}` : ''
  let pagesize = !!PageSize ? `&PageSize=${PageSize}` : ''
  let codigoPromotor = !!CodigoPromotor
    ? `CodigoPromotor=${CodigoPromotor}`
    : ''
  let idPedido = !!IdPedido ? `&IdPedido=${IdPedido}` : ''
  let datainicial = !!DataInicial
    ? `&DataInicial=${DataInicial.replace('/', '%2F')}`
    : ''
  let datafinal = !!DataFinal
    ? `&DataFinal=${DataFinal.replace('/', '%2F')}`
    : ''

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_PEDIDOS}api/venda-promovida?${codigoPromotor}${idPedido}${datainicial}${datafinal}${page}${pagesize}`,
    {
      headers: defaultOptions.headers
    }
  )

  return data as GetVendasPromovidasResponse
}
